import Widget, { type DataEntry, type WidgetProps } from './Widget';

export type { DataEntry, WidgetProps };
export default Widget;
